export default __webpack_public_path__ + "static/media/products_571.29aebaf0.jpg";